/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { KTSVG } from 'src/_metronic/helpers';

const Step5: FC = () => {
  return (
    <div className="w-100">
      <div className="pb-8 pb-lg-10">
        <h2 className="fw-bolder text-dark">Kaydınız Alındı!</h2>
      </div>

      <div className="mb-0">
        <div className="fs-6 text-gray-600 mb-5">
          Düğün Takibi ailesine hoş geldiniz! Kayıt işleminiz başarıyla tamamlandı.
          <span className="fw-bold text-dark"> Üyeliğiniz onaylandığında sistemi kullanmaya başlayabilirsiniz.</span> Onay
          süreci ve detaylı bilgi için Düğün Takibi ile iletişime geçebilirsiniz. Aramıza katıldığınız için teşekkür ederiz!
        </div>
      </div>
    </div>
  );
};

export { Step5 };
